export function phpDate(dateValue: number | string): Date {
    const utcMs = typeof dateValue === "number" ? dateValue * 1000 : Date.parse(dateValue);
    const utcDate = new Date(utcMs);

    return localDate(utcDate);
}

export function isValidDate(date: any): boolean {
    const dt = new Date(date);

    return !isNaN(dt.getTime());
}

export function utcHour(hour: number): number {
    const date = new Date();
    date.setHours(hour);

    return date.getUTCHours();
}

export function localHour(utcHour: number): number {
    const date = new Date();
    date.setUTCHours(utcHour);

    return date.getHours();
}

export function utcMinute(minute: number): number {
    const date = new Date();
    date.setMinutes(minute);

    return date.getUTCMinutes();
}

export function localMinute(utcMinute: number): number {
    const date = new Date();
    date.setUTCMinutes(utcMinute);

    return date.getMinutes();
}

export function utcWeekday(weekday: number): number {
    const date = new Date();
    date.setDate(date.getDate() + ((7 + weekday - date.getDay()) % 7));

    return date.getUTCDay();
}

export function localWeekday(utcWeekday: number): number {
    const date = new Date();
    date.setUTCDate(date.getUTCDate() + ((7 + utcWeekday - date.getUTCDay()) % 7));

    return date.getDay();
}

export const MS_IN_A_DAY = 24 * 60 * 60 * 1000;

export function getDates(numberOfDates: number, startDate = new Date()): Date[] {
    const dates: Date[] = [];

    for (let i = 0; i < numberOfDates; i++) {
        const time = startDate.getTime() + i * MS_IN_A_DAY;
        const date = new Date(time);
        dates.push(date);
    }

    return dates;
}

export function offsetMs() {
    return new Date().getTimezoneOffset() * 60 * 1000;
}

export function utcDate(localDate: Date): Date {
    const localMs = localDate.getTime();

    const ms = localMs - offsetMs();
    const utcDate = new Date(ms);

    return utcDate;
}

export function localDate(utcDate: Date): Date {
    const utcMs = utcDate.getTime();

    const ms = utcMs + offsetMs();
    const localDate = new Date(ms);

    return localDate;
}
